module.exports = __webpack_public_path__ + "img/info.234b7b55.svg";